import template from './loaderScreen.html';
import controller from './loaderScreen.controller';
import './loaderScreen.scss';

let loaderScreenComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default loaderScreenComponent;



// WEBPACK FOOTER //
// ./client/app/components/loaderScreen/loaderScreen.component.js